import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';

import useOrderPrepaidCard
  from './hooks/useOrderPrepaidCard';

interface Props {
    prepaidCardImageId: string;
}

function PurchaseButton({ prepaidCardImageId }:Props) {
  const { handlePurchase, amount, orderDisabled } = useOrderPrepaidCard(prepaidCardImageId);
  return (
        <Column
                fullWidth
                spacing={16} >
            <Row fullWidth justify='space-between'>
                <Text size='xl' fontWeight='bold'>결제금액</Text>
                <Text size='3xl' fontWeight='bold' color={colors.red}>
                    {amount.toLocaleString()}원
                </Text>
            </Row>
            <Button fullWidth onClick={handlePurchase}
                    disabled={orderDisabled} >
                결제하기
            </Button>
        </Column>
  );
}

export default PurchaseButton;
